import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { useEffect, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import DownloadIcon from "@mui/icons-material/Download";
import PaymentsList from "../../features/managePayments/paymentsList";
import useTranslation from "../../hooks/traslation";
import {
  useLazyGetPaymentQuery,
  useLazyGetUserCSVQuery,
} from "../../services/payment";
import { showError } from "../../constants/toasts";
import useAuth from "../../hooks/useAuth";
import { isValidInput } from "../../utils/validations";
import { useLazyGetCategoryByIdQuery } from "../../services/category";
import { PaymentResponse } from "../../types/General";



const ManagePayments = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const translate = useTranslation();
  const [rows, setRows] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [commision, setCommision] = useState<PaymentResponse>();

  const [getPayment] = useLazyGetPaymentQuery();
  const [exportPayment] = useLazyGetUserCSVQuery();


  const handleExportCsv = async () => {
    try {
      setIsLoading(true);
      const res = await exportPayment({ search: debouncedSearchTerm }).unwrap();
      if (res?.statusCode === 200) {
        if (res?.data?.length > 0) {
          window.open(res?.data || "");
        }
        return;
      }
    } catch (error: any) {
      showError(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event: any, newPage: number) => {
    const updatedPage = newPage + 1;
    setPage(updatedPage);

    const params = new URLSearchParams(window.location.search);
    params.set("page", updatedPage.toString());

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  const getAllPayment: any = async () => {
    setIsLoading(true);
    try {
      const response = await getPayment({
        page,
        limit: limit,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
     
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data?.result[0]?.list || []);
        setCount(response?.data?.result[0]?.totalCount);
        setCommision(response);
      } else {
        setIsLoading(false);
        setRows([]);
      }
    } catch (error: any) {
      setIsLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getAllPayment();
  }, [page, debouncedSearchTerm, limit]);
  return (
    <MainContainer>
      <div className="main_title">
        <h1>{translate?.main?.managePayment}</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>
            {translate?.dashboard?.dashboard}
          </span>{" "}
          - {translate?.main?.managePayment}
        </p>
      </div>
      <div className="stats_boxes gap_m">
        <div
          className="cards"
          // onClick={() => navigate("/dashboard/unregistered-users")}
        >
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          {isLoading ? (
            <CircularProgress size={24} />
          ) : (
            <h2>{commision?.data?.totalServiceFees}</h2>
          )}
          <p>{translate?.main?.managePaymentDetail}</p>
        </div>
      </div>

      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder={translate.user.SearchHere}
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <Button className="btn btn_grey" onClick={handleExportCsv}>
              <DownloadIcon />
              {translate?.main?.export}
            </Button>
          </div>
        </div>
        {isLoading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center", padding: "2rem" }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <PaymentsList
              rows={rows}
              isLoading={isLoading}
              count={count}
              page={page}
              onPageChange={handlePageChange}
            />
            {rows.length !== 0 && (
              <div className="table_footer">
                <div className="pagination_info">
                  <span className="total_records">Showing {rows.length} of {count} records</span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </MainContainer>
  );
};

export default ManagePayments;
